import { render, staticRenderFns } from "./ChildrenListWindow.vue?vue&type=template&id=0d6db3ef&scoped=true&"
import script from "./ChildrenListWindow.vue?vue&type=script&lang=js&"
export * from "./ChildrenListWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenListWindow.vue?vue&type=style&index=0&id=0d6db3ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6db3ef",
  null
  
)

export default component.exports